import { colors, fonts } from './theme';
export const labelStyle = {
    fontSize: 28,
    letterSpacing: '0.24em',
    textTransform: 'uppercase',
    color: colors.muted,
};
export const hintStyle = {
    fontSize: 28,
    color: colors.muted,
};
export const bigNickStyle = {
    fontFamily: fonts.serif,
    fontStyle: 'italic',
    fontWeight: 500,
    fontSize: 120,
    lineHeight: 1,
    whiteSpace: 'nowrap',
};
export const timerStyle = {
    fontWeight: 700,
    lineHeight: 1,
    fontVariantNumeric: 'lining-nums tabular-nums',
};
export const ellipsisStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
};
